import moment from 'moment';
import { createImmerReducer } from '@reducers/utils/createReducer';
import * as c from './types';
import { OperatorTimelineParams } from '@clean-code/api/hooks/useOperatorTimeline';
import { PaginatedRequest } from '@clean-code/types/common';

const getDefaultDateRange = () => ({
  from: moment().subtract(2, 'day').startOf('day').toISOString(),
  to: moment().endOf('day').toISOString()
});

const initialState: c.OperatorTimelineState = {
  filter: {
    dateRange: getDefaultDateRange(),
    machineIds: [],
    operatorIds: [],
    shifts: [],
    status: ['assigned', 'unassigned']
  },
  //TODO: pending backend sorting
  sorting: {
    column: 'range_from',
    direction: 'desc'
  },
  pagination: {
    page: 1,
    pageSize: 100
  }
};

export default createImmerReducer(initialState, {
  [c.SET_OPERATOR_FILTER]: (
    draft: c.OperatorTimelineState,
    { payload }: { payload?: OperatorTimelineParams }
  ) => {
    if (!payload) return;
    draft.filter = payload;
    draft.pagination.page = 1; // reset page on filter change
  },
  [c.RESET_OPERATOR_FILTERS]: (draft: c.OperatorTimelineState) => {
    draft.filter = {
      ...initialState.filter,
      dateRange: getDefaultDateRange()
    };
    draft.pagination = initialState.pagination;
    draft.sorting = initialState.sorting;
  },
  [c.SET_OPERATOR_SORTING]: (
    draft: c.OperatorTimelineState,
    { payload }: { payload?: c.OperatorSorting }
  ) => {
    if (!payload) return;
    draft.sorting = payload;
    draft.pagination.page = 1;
  },
  [c.SET_OPERATOR_PAGINATION]: (
    draft: c.OperatorTimelineState,
    { payload }: { payload?: PaginatedRequest }
  ) => {
    if (!payload) return;
    draft.pagination = payload;
  }
});
